import { ProgramBroadcastFiltersState } from '@/stores/program-broadcast-filters';

export const segmentsQueryKeys = {
  all: ['segments'] as const,
  segmentLogo: ['segment-logo'] as const,
  segmentPeople: ['segment-people'] as const,
  segmentDeclaration: ['segment-declaration'] as const,
  id: (id: string) => [...segmentsQueryKeys.all, id] as const,

  mentionFacets: (range: { gte?: string; lte?: string }) =>
    [...segmentsQueryKeys.all, 'mention-facets', range] as const,

  infinite: () => [...segmentsQueryKeys.all, 'infinite'] as const,
  infiniteList: (filters?: Partial<ProgramBroadcastFiltersState>) =>
    [...segmentsQueryKeys.infinite(), filters] as const,
};
